import { Component } from '@angular/core';
import { Permissao } from '@models/enums/permissao';

interface Atalho {
  titulo: string;
  descricao: string;
  icone: string;
  url: string;
  permissao: Permissao;
  classe: string;
}

interface ModuloAtalhos {
  titulo: string;
  atalhos: Atalho[];
}

@Component({
  selector: 'app-tela-inicial',
  templateUrl: './tela-inicial.component.html',
  styleUrl: './tela-inicial.component.scss',
  standalone: false,
})
export class TelaInicialComponent {

  protected readonly modulos: ModuloAtalhos[] = [
    {
      titulo: 'Financeiro',
      atalhos: [
        { titulo: 'Movimentação do Caixa', descricao: 'Lotes e lançamentos das contas do caixa', icone: 'monetization_on', url: '/movimentacao-caixa', permissao: Permissao.VISUALIZAR_MOVIMENTACAO_CAIXA, classe: 'btn-movimentacao-caixa' },
        { titulo: 'Painel Financeiro', descricao: 'Resumo das contas do caixa e do banco', icone: 'dashboard', url: '/painel-financeiro', permissao: Permissao.VISUALIZAR_PAINEL_FINANCEIRO, classe: 'btn-painel-financeiro' },
        { titulo: 'Relatório Financeiro', descricao: 'Relatórios das contas do caixa', icone: 'assessment', url: '/relatorio-financeiro', permissao: Permissao.VISUALIZAR_RELATORIO_CAIXA, classe: 'btn-relatorio-financeiro' },
        { titulo: 'Configuração do Caixa', descricao: 'Contas e tipos de lançamento', icone: 'settings', url: '/configuracao-caixa', permissao: Permissao.VISUALIZAR_CONFIGURACAO_CAIXA, classe: 'btn-configuracao-caixa' },
      ],
    },
    {
      titulo: 'Vistoria',
      atalhos: [
        { titulo: 'Vistorias', descricao: 'Criar e acompanhar vistorias de imóveis', icone: 'home_work', url: '/vistoria', permissao: Permissao.REALIZAR_VISTORIA, classe: 'btn-vistorias' },
        { titulo: 'Modelos de Vistoria', descricao: 'Modelos usados como base das vistorias', icone: 'assignment', url: '/vistoria/modelos', permissao: Permissao.EDITAR_ROTEIRO_VISTORIA, classe: 'btn-modelos-vistoria' },
      ],
    },
    {
      titulo: 'Usuários',
      atalhos: [
        { titulo: 'Gerenciar Perfis dos Usuários', descricao: 'Usuários, papéis e permissões', icone: 'group', url: '/gerenciar-perfis-usuarios', permissao: Permissao.ADMINISTRAR_CONTAS, classe: 'btn-gerenciar-perfis-usuarios' },
      ],
    },
  ];

  protected permissoesModulo(modulo: ModuloAtalhos): Permissao[] {
    return modulo.atalhos.map(a => a.permissao);
  }
}
